import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between" }, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createTextVNode(" Êtes-vous sûr(e) qu'il s'agit d'un retrait en espèce ? ")),
        (_ctx.step)
          ? (_openBlock(), _createBlock(_component_v_avatar, {
              key: 0,
              color: "primary-lighten-2",
              class: "subheading white--text",
              size: "24"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.step), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text),
    (!_ctx.actions)
      ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              rounded: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel())),
              class: "mx-auto",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.step ? "Précédent" : "Annuler"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              rounded: "",
              onClick: _ctx.validate,
              loading: _ctx.loading,
              size: "small"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Oui, je suis sûr(e) ")
              ])),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}